/**
 * TipoOcorrencia
 * @author Simpli CLI generator
 */
import {$, HttpBody, ID, Resource, ResponseSerialize, TAG} from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import TipoOcorrenciaSchema from '@/schema/TipoOcorrencia.schema'
import Responsavel from '@/model/resource/Responsavel'

export default class TipoOcorrencia extends Resource {
  get $schema() {
    return TipoOcorrenciaSchema(this)
  }

  get $id() {
    return this.idOcorrenciaPk
  }
  set $id(val: ID) {
    this.idOcorrenciaPk = val
  }
  get $tag() {
    return this.nome
  }
  set $tag(val: TAG) {
    this.nome = val
  }

  static async persistLoteTipoOcorrencia(listToPersist: TipoOcorrencia[], spinner = 'persistLoteTipoOcorrencia') {
    const fetch = async () => {
      return await new HttpBody(Number).POST(`/user/lote-tipo-ocorrencia`, listToPersist)
    }

    return await $.await.run(fetch, spinner)
  }

  readonly $name: string = 'TipoOcorrencia'

  readonly $endpoint: string = '/user/tipo-ocorrencia{/id}'

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  idOcorrenciaPk: ID = 0

  idOcorrenciaExterna: number | null = null

  @ValidationRequired()
  @ValidationMaxLength(100)
  nome: string = ''

  @ValidationRequired()
  ativo: boolean = false

  @ValidationRequired()
  ehDevolvida: boolean = false

  async persistTipoOcorrencia(spinner = 'persistTipoOcorrencia') {
    const fetch = async () => {
      await this.validate()
      return await this.POST(`/user/tipo-ocorrencia`, this)
    }

    return await $.await.run(fetch, spinner)
  }

  async getTipoOcorrencia(id: ID, spinner = 'getTipoOcorrencia') {
    const fetch = async () => await this.GET(`/user/tipo-ocorrencia/${id}`)
    return await $.await.run(fetch, spinner)
  }

  async removeTipoOcorrencia(id: number, spinner = 'removeTipoOcorrencia') {
    const fetch = async () => await this.DELETE(`/user/tipo-ocorrencia/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
